import {
    Card,
    CardContent,
    DialogContent,
    DialogTitle,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import Helper from '../../../../../../../utils/helper';
import { OIC_DI } from '../orderInformationCard.classes';

function DiscountInfo({ discounts }: any) {
    const { t } = useTranslation();
    return (
        <Card className={OIC_DI.root} style={{ minWidth: '700px' }}>
            <DialogTitle className={OIC_DI.title} style={{ textAlign: 'center' }}>
                {t('orderDetail.allDiscounts')}
            </DialogTitle>
            <DialogContent className={OIC_DI.dialogContent}>
                <CardContent className={OIC_DI.contentInner}>
                    <Table className={OIC_DI.table} size="small">
                        <TableHead>
                            <TableRow className={OIC_DI.headerRow}>
                                <TableCell>{t('orderDetail.campaignId')}</TableCell>
                                <TableCell>{t('orderDetail.campaignName')}</TableCell>
                                <TableCell>{''}</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {discounts.map((discount: any) => (
                                <TableRow className={OIC_DI.discountRow} key={discount.discountSourceId}>
                                    <TableCell>
                                        <p style={{}}>{discount.discountSourceId}</p>
                                    </TableCell>
                                    <TableCell>
                                        <p style={{ color: 'red' }}>{discount.discountDescription}</p>
                                    </TableCell>
                                    <TableCell>
                                        <p style={{ fontWeight: 'bold' }}>
                                            {Helper.formatCurrencyByCountry(
                                                discount.discountFloat || NaN,
                                                JSON.parse(localStorage.getItem('selectedCountry') || '{}')?.countryCode
                                            )}
                                            {discount.currency}
                                        </p>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                    <div className={OIC_DI.footerDivider} style={{ height: '1px', backgroundColor: 'lightgray' }}></div>
                    <p className={OIC_DI.footerTotal} style={{ color: 'gray', fontSize: '10px', textAlign: 'right' }}>
                        {`${t('orderDetail.totalDiscountCount')}: ${discounts.length}`}
                    </p>
                </CardContent>
            </DialogContent>
        </Card>
    );
}

export default DiscountInfo;
